export default __webpack_public_path__ + "static/media/8.30791f23.png";